import React from 'react';
import { PortfolioTableItemDetails } from '../PortfolioTableItem';
import { formatDate } from '../../../utils/dateUtils';
import { SectionBlock } from './SectionBlock';
import { useTranslation } from 'react-i18next';

type DetailsSectionProps = { portfolio: PortfolioTableItemDetails };

export const DetailsSection: React.FC<DetailsSectionProps> = ({ portfolio }) => {
  const { t } = useTranslation();
  const detailItems = [
    { label: t('pb.productdetails.details.createdBy.label'), value: portfolio.createdBy ?? '' },
    {
      label: t('pb.productdetails.details.activationDate.label'),
      value: formatDate(portfolio.activatedAt),
      testId: 'portfolio-detail-activation-date',
    },
    {
      label: t('pb.productdetails.details.closureDate.label'),
      value: formatDate(portfolio.closedAt),
      testId: 'portfolio-detail-closure-date',
    },
    ...(portfolio.draftServiceModel
      ? [
          {
            label: t('pb.productdetails.details.product.label'),
            value: portfolio.draftServiceModel.productDisplayName ?? '-',
            testId: 'product-detail-product-name',
          },
          {
            label: t('pb.productdetails.details.formerProduct.label'),
            value: portfolio.serviceModel?.productDisplayName ?? '-',
            testId: 'product-detail-former-product-name',
          },
        ]
      : [
          {
            label: t('pb.productdetails.details.product.label'),
            value: portfolio.serviceModel?.productDisplayName ?? '-',
            testId: 'product-detail-product-name',
          },
        ]),
    {
      label: t('pb.productdetails.details.engagementType.label'),
      value: portfolio.serviceModel?.engagementTypeName ?? '-',
      testId: 'product-detail-engagement-type',
    },
    {
      label: t('pb.productdetails.details.serviceModel.label'),
      value: portfolio.serviceModel?.serviceModelName ?? '-',
      testId: 'product-detail-service-model',
    },
    {
      label: t('pb.productdetails.details.productLine.label'),
      value: portfolio.serviceModel?.productLineName ?? '-',
      testId: 'product-detail-product-line',
    },
    {
      label: t('pb.productdetails.details.productImplementation.label'),
      value: portfolio.serviceModel?.productImplementationName ?? '-',
      testId: 'product-detail-product-implementation',
    },
    {
      label: t('pb.productdetails.details.investmentStrategy.label'),
      value: portfolio.serviceModel?.investmentStrategyName ?? '-',
      testId: 'product-detail-investment-strategy',
    },
    {
      label: t('pb.productdetails.details.bankingServicePackage.label'),
      value: '-',
      testId: 'product-detail-banking-service-package',
    },
    {
      label: t('pb.productdetails.details.transactionFeeModel.label'),
      value: portfolio.serviceModel?.transactionFeeModelName ?? '-',
      testId: 'product-detail-transaction-fee',
    },
    {
      label: t('pb.productdetails.details.currency.label'),
      value: portfolio.serviceModel?.currencyCode ?? '-',
      testId: 'product-detail-currency',
    },
  ];

  return <SectionBlock list={detailItems} />;
};
